import { render, staticRenderFns } from "./TestDataMainFormForm.vue?vue&type=template&id=74e0b177"
import script from "./TestDataMainFormForm.vue?vue&type=script&lang=js"
export * from "./TestDataMainFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e0b177')) {
      api.createRecord('74e0b177', component.options)
    } else {
      api.reload('74e0b177', component.options)
    }
    module.hot.accept("./TestDataMainFormForm.vue?vue&type=template&id=74e0b177", function () {
      api.rerender('74e0b177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/onetomany/TestDataMainFormForm.vue"
export default component.exports